import { getGuessStatuses } from '../../lib/statuses'
import { Cell } from './Cell'

type Props = {
  guess: string
  isRevealing?: boolean
}

export const PreviousRow = ({ guess, isRevealing }: Props) => {
  const statuses = getGuessStatuses(guess)
  // console.log(statuses);
  
  return (
    <div className="flex justify-center ">
      
      {guess.split('').map((letter, i) => (
        <Cell
          key={i}
          value={letter}
          status={statuses[i]}
          position={i}
          isRevealing={isRevealing}
          isCompleted
        />
      ))}
    </div>
  )
}
